import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'src/services/redux';

interface PreferencesState {
  reorderCollectionsWarningDismissed: boolean;
}

const initialState: PreferencesState = {
  reorderCollectionsWarningDismissed: false,
};

export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setPreference: <K extends keyof PreferencesState>(
      state: PreferencesState,
      action: PayloadAction<{ key: K; value: PreferencesState[K] }>,
    ) => {
      state[action.payload.key] = action.payload.value;
    },
  },
});

export const { setPreference } = preferencesSlice.actions;

export const selectPreferences = (state: RootState) => state[preferencesSlice.name];
